<template>
  <div>
    <div id="menu-bar-portal" class="d-flex align-content-space-between" v-if="$vuetify.breakpoint.lgAndUp">
      <div class="top w-100 pt-2 flex-shrink-0">
        <!-- Logo Section -->
        <v-container class="d-flex justify-center align-center" :color="portal_menubar_background" height="60">
          <v-img v-if="companylogo_url=='default'" contain :max-height="logo_height" :max-width="logo_width" :min-height="logo_height" :min-width="logo_width" plain src="../assets/images/UPGPT.png"></v-img>
          <v-img v-else-if="companylogo_url!='default' && companylogo_url!=''" contain :max-height="logo_height" :max-width="logo_width" :min-height="logo_height" :min-width="logo_width" plain :src="companylogo_url"></v-img>
        </v-container>
        <!-- <div v-if="companylogo_url!='default' && companylogo_url!=''" class="poweredby mx-auto" style="text-align: center;">Powered by UpGPT</div> -->
        <!-- New Chat Button -->
        <v-container class="d-flex flex-column align-center" style="padding: 24px 0 0 0 ;">
          <v-btn
              class="m-16-10-button mb-6"
              :color="new_question_btn"
              outlined
              rounded
              @click="toLanding(); "
          >
            <div
              class="cross-box"
            >
            </div>
            <span class="h5-en blue-text ">{{ $t('MenuBarPortal.NEW_THREAD') }}</span>
          </v-btn>
        </v-container>
      </div>
          <!-- <v-btn class="justify-start pl-6" color='transparent' elevation='0' width="100%" @click="change_main_view('agent')">
            <v-img max-height="20.84" max-width="20.5" class="" src="../assets/images/ai-agent-icon.svg"></v-img>
            <span class="h4-en pl-2">{{ $t('AGENT.TITLE') }}</span>
          </v-btn> -->
      <div class="middle flex-grow-1 d-flex flex-column overflow-hidden">
          <!-- Thread list -->
        <div :class="['d-flex', 'flex-column', showDocumentAgent ? 'flex-shrink-0' : 'flex-grow-1 overflow-hidden']" v-show="threadHistory.length > 0">
          <v-container class="add_thread flex-shrink-0">
            <v-img
                contain
                max-height="20.84"
                max-width="20.5"
                plain
                src="../assets/images/thread-record-icon.svg"
                style="margin-right: 4.29px"
            ></v-img>
            <span class="h4-en">{{ $t("MenuBarPortal.THREAD_HISTORY") }}</span>
          </v-container>
          <div :class="['custom-scroll-area', showDocumentAgent ? 'history-list-wrapper' : 'history-list-wrapper-expanded']">
            <v-container class="add_thread_lists py-0">
              <v-list class="p-0 custom-list " :color="portal_menubar_background" elevation="0">
                <v-list-item
                    v-for="(item, index) in threadHistory"
                    :key="index"
                    class="list_items"
                    @click="updateseletedThread(index, item)"
                    @mouseenter="hoverIndex = index"
                    @mouseleave="hoverIndex = null"
                >
                  <!-- 左側 Icon -->
                  <v-list-item-icon class="m-0">
                    <div
                        :class="selectedThread === index ? 'selected-thread-border'  : 'default-thread-border'"
                    ></div>
                  </v-list-item-icon>

                  <!-- 文字 -->
                  <v-list-item-content class="p-0">
                    <v-list-item-title
                        :class="{'selected-text': selectedThread === index, 'default-text': selectedThread !== index }"
                        :title="item.content" 
                    >
                      {{ item.content }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action v-show="hoverIndex == index">
                    <v-btn :ripple='false' plain icon @click.stop="deleteSeletedThread(item)">
                      <v-icon size='15' color="#444">icon-remove</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

            </v-container>
          </div>
        </div>
          <!-- 文件代理中心 -->
        <div class="agent-section d-flex flex-column flex-grow-1 min-height-0" v-if="showDocumentAgent">
          <v-container class="add_thread flex-shrink-0">
            <v-img
                contain
                max-height="20.84"
                max-width="20.5"
                plain
                src="../assets/images/document-agent-icon.svg"
                style="margin-right: 4.29px"
            ></v-img>
            <span class="h4-en">{{ $t("DOCUMENT_AGENT.TITLE") }}</span>
            <v-btn
                class="ml-auto"
                icon
                dense
                @click="toDocumentAgentTemplate(); ">
                <v-img
                    contain
                    max-height="18"
                    max-width="18"
                    src="../assets/images/add_document_agent_button.svg"
                    style="margin-right: 4px;"
                >
                </v-img>
            </v-btn>
          </v-container>
          <div class="agent-list-wrapper custom-scroll-area flex-grow-1">
            <v-container class="add_thread_lists py-0">
              <v-list class="p-0 custom-list " color="#F3F3EE" elevation="0">
                <v-list-item
                    v-for="(item, index) in documentAgentHistory"
                    :key="index"
                    class="list_items"
                    @click="updateDocumentAgent(index, item)"
                    @mouseenter="agenthoverIndex = index"
                    @mouseleave="agenthoverIndex = null"
                >
                  <!-- 左側 Icon -->
                  <v-list-item-icon class="m-0">
                    <v-img
                        :src="selectedAgentIndex === index ? selectedIcon  : defaultIcon"
                        height="36"
                        max-width="2"
                    ></v-img>
                  </v-list-item-icon>

                  <!-- 文字 -->
                  <v-list-item-content class="p-0">
                    <v-list-item-title
                        :class="{'selected-text': selectedAgentIndex === index, 'default-text': selectedAgentIndex !== index }"
                        :title="item.content" 
                    >
                      {{ item.content }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action v-show="agenthoverIndex == index">
                    <v-btn :ripple='false' plain icon @click.stop="deleteSelectedUserAgent(item)">
                      <v-icon size='15' color="#444">icon-remove</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-container>
          </div>
        </div>
      </div>
      <div class="bottom flex-shrink-0" v-if="!hideAvatar && menuMember.userid != ''">
        <div v-if="hideAvatar"></div>
        <div v-else-if="menuMember.userid != ''">
          <div class='d-flex justify-start align-center px-4 user_info_box'>
            <v-avatar color="aliceBlue" size="36">
              <span v-if="menuMember.pic === ''">{{ menuMember.nickname }}</span>
              <img v-else :alt="menuMember.name" :src="member.pic"/>
            </v-avatar>
            <div class=" mr-4 ml-1" style="width: 120px;">
                            <span class='p1-en-regular'>
                                {{ menuMember.name }}
                            </span>
            </div>
            <div class="">
              <v-menu  v-if="show_private_knowledge"  :offset-x="true" nudge-right="0" open-on-hover min-width="180" :z-index="999">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-img max-width="24" max-height="24" src="../assets/images/gear.svg" />
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="toMyKnowledge">
                    <v-list-item-title class="p1-tc-500">{{ $t('PORTAL.MY_KNOWLEDGE') }} </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="toUserSetting">
                    <v-list-item-title class="p1-tc-500">{{ $t('SETTING.PERSONALSETTING') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn v-else icon @click="toUserSetting">
                  <v-img max-width="24" max-height="24" src="../assets/images/gear.svg" />
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <v-dialog v-if='messageDialog' v-model='messageDialog' content-class='statusDialog' width='360'>
        <message-dialog :message='message' @emitMessageDialog='onEmitMessageDialog'></message-dialog>
      </v-dialog>
    </div>
    <v-app-bar id="menu-bar-portal-mobile" :class="isUpsideExtension ? 'pt-3':''" :elevation="0" :height="isUpsideExtension ? 80:60" v-if="$vuetify.breakpoint.mdAndDown" location="top" scroll-behavior="elevate" style="position: fixed; top: 0; z-index: 2; ">
        <v-app-bar-nav-icon @click.stop="drawer=!drawer" style="position: fixed;"></v-app-bar-nav-icon>
        <div class="pa-0 d-flex flex-column align-center justify-center w-100">
          <v-img :class="isUpsideExtension ? 'upside-logo-style':''" v-if="companylogo_url == 'default'" contain :max-height="logo_height" :max-width="logo_width" plain src="../assets/images/UPGPT.png"></v-img>
          <v-img :class="isUpsideExtension ? 'upside-logo-style':''" v-else-if="companylogo_url!='default' && companylogo_url!=''" contain :max-height="logo_height" :max-width="logo_width" plain :src="companylogo_url"></v-img>
          <!-- <div v-if="companylogo_url!='default' && companylogo_url!=''" class="poweredby-mobile">Powered by UpGPT</div> -->
        </div>
      <template v-if="isUpsideExtension">
        <v-btn class="px-4 pb-2 mr-2" icon small>
          <v-icon color="#abaaaa" size="18">mdi-logout</v-icon>
        </v-btn>
        <v-btn class="px-3 pb-2 mr-2" icon small>
          <v-icon color="#abaaaa" size="18">mdi-minus</v-icon>
        </v-btn>
        <v-btn class="px-3 pb-2" icon small>
          <v-icon color="#abaaaa" size="18">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-app-bar>
    <v-navigation-drawer class="menu-bar-drawer border-0 mobile-drawer-with-footer-space" v-if="$vuetify.breakpoint.mdAndDown"  v-model='drawer' :width="endPointDrawerWidth" :color="portal_menubar_background" absolute left mobile hide-overlay style="z-index: 21;">
      <v-container class="pt-4 d-flex justify-center align-center w-100">
        <v-img v-if="companylogo_url=='default'" class="" contain :max-height="logo_height" :max-width="logo_width" plain src="../assets/images/UPGPT.png"></v-img>
        <v-img v-else-if="companylogo_url!='default' && companylogo_url!=''" class="" contain :max-height="logo_height" :max-width="logo_width" plain :src="companylogo_url"></v-img>
      </v-container>
       <!-- <div v-if="companylogo_url!='default' && companylogo_url!=''" class="poweredby mx-auto d-flex justify-center align-center">Powered by UpGPT</div> -->
      <v-container class="d-flex justify-center align-center">
        <v-btn
            class="m-16-10-button"
            :color="new_question_btn"
            outlined
            rounded
            @click="toLanding(); "
        >
          <div
            class="cross-box"
          >
          </div>
          <span class="h5-en blue-text ">{{ $t('MenuBarPortal.NEW_THREAD') }}</span>
      </v-btn>
    </v-container>
    <v-container class="">
      <!-- <v-btn class="justify-start pl-0" color='transparent' elevation='0' width="100%" @click="change_main_view('agent')">
          <v-img max-height="20.84" max-width="20.5" class="" src="../assets/images/ai-agent-icon.svg"></v-img>
          <span class="h4-en pl-2">Agents</span>
      </v-btn> -->
    </v-container>
    <v-container v-show="threadHistory.length > 0" class="d-flex add_thread align-items-center">
      <v-img
          contain
          max-height="20.84"
          max-width="18.5"
          plain
          src="../assets/images/thread-record-icon.svg"
          style="margin-right: 4.29px"
      ></v-img>
      <span class="h4-en">{{ $t("MenuBarPortal.THREAD_HISTORY") }}</span>
    </v-container>
    <v-container v-show="threadHistory.length > 0" class=" add_thread_lists">
      <v-list class="p-0 custom-list menu-portal-mobile" :color="portal_menubar_background" elevation="0">
        <v-list-item
            v-for="(item, index) in threadHistory"
            :key="index"
            class="list_items"
            @click="updateseletedThread(index, item)"
            @mouseenter="hoverIndex = index"
            @mouseleave="hoverIndex = null"
        >
          <!-- 左側 Icon -->
          <v-list-item-icon class="m-0">
            <div
                :class="selectedThread === index ? 'selected-thread-border-mobile'  : 'default-thread-border-mobile'"
            ></div>
          </v-list-item-icon>

          <!-- 文字 -->
          <v-list-item-content class="p-0">
            <v-list-item-title
                :class="{'selected-text': selectedThread === index, 'default-text': selectedThread !== index }"
            >
              {{ item.content }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action class="my-0" v-show="hoverIndex == index">
            <v-btn :ripple='false' plain icon @click.stop="deleteSeletedThread(item)">
              <v-icon size='17' color="#444">icon-remove</v-icon>
            </v-btn>
          </v-list-item-action>
          
        </v-list-item>
      </v-list>
      </v-container>
    <v-container v-if="showDocumentAgent" v-show="documentAgentHistory.length > 0" class="d-flex add_thread align-items-center" >
      <v-img
          contain
          max-height="20.84"
          max-width="18.5"
          plain
          src="../assets/images/document-agent-icon.svg"
          style="margin-right: 4.29px"
      ></v-img>
      <span class="h4-en">{{ $t("DOCUMENT_AGENT.TITLE") }}</span>
      <v-btn
          class="ml-auto"
          icon
          dense
          @click="toDocumentAgentTemplate(); "
      >
        <v-img
            contain
            max-height="18"
            max-width="18"
            src="../assets/images/add_document_agent_button.svg"
            style="margin-right: 4px;"
        >
        </v-img>
      </v-btn>
    </v-container>

    <!-- 手機版 Document Agent list -->
    <v-container v-if="showDocumentAgent" v-show="documentAgentHistory.length > 0" class="add_thread_lists" >
      <v-list class="p-0 custom-list menu-portal-mobile" :color="portal_menubar_background" elevation="0">
        <v-list-item
            v-for="(item, index) in documentAgentHistory"
            :key="'agent-' + index"
            class="list_items"
            @click="updateDocumentAgent(index, item)"
            @mouseenter="agenthoverIndex = index"
            @mouseleave="agenthoverIndex = null"
        >
          <!-- 左側 Icon -->
          <v-list-item-icon class="m-0">
            <v-img
                :src="selectedAgentIndex === index ? selectedIcon : defaultIcon"
                height="36"
                max-width="2"
            ></v-img>
          </v-list-item-icon>

          <!-- 文字 -->
          <v-list-item-content class="p-0">
            <v-list-item-title
                :class="{'selected-text': selectedAgentIndex === index, 'default-text': selectedAgentIndex !== index }"
                :title="item.content"
            >
              {{ item.content }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action class="my-0" v-show="agenthoverIndex == index">
            <v-btn :ripple='false' plain icon @click.stop="deleteSelectedUserAgent(item)">
              <v-icon size='17' color="#444">icon-remove</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-container>
      <div v-if="hideAvatar"></div>
      <div v-else-if="menuMember.userid != ''" class="my-4" style="width: 100%; position: absolute; bottom: 0;">
        <div class='d-flex justify-space-between align-center px-4 '>
          <div class="d-flex align-center">
            <v-avatar color="aliceBlue" size="36">
              <span v-if="menuMember.pic === ''">{{ menuMember.nickname }}</span>
              <img v-else :alt="menuMember.name" :src="member.pic"/>
            </v-avatar>
            <div class=" mr-4 ml-1">
              <span class='p1-en-regular'>
                  {{ menuMember.name }}
              </span>
            </div>
          </div>
          <div class="">
            <v-btn v-hide-element='false' icon @click="toUserSetting()">
              <v-img max-height="24" max-width="24" src="../assets/images/gear.svg"></v-img>
            </v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PersonalSettingService from "@/services/PersonalSettingService";
import passData from "@/services/passData.js";
import i18n from '/common/plugins/vue-i18n.js';
import messageDialog from '@/components/Dialog/messageDialog';
import UpGPTPortalDataServices from "../services/UpGPTPortalDataServices";
import PreferenceService from "@/services/PreferenceService";

export default {
  name: 'MenuBar',
  props: {
    member: {
      type: Object
    },
    generating: {
        type: Boolean,
        require:true,
    },
    companylogo_url: {
        type: String,
        require:true,
    },
    show_private_knowledge: {
      type: Boolean,
      require:true,
    }
  },
  components: {
    messageDialog
  },
  data() {
    return {
      upgpt_settingRouter:
          {
            path: '/upgpt/UserSetting/',
            name: i18n.t('SETTING.PERSONALSETTING'),
            normal: 'mdi-account',
            active: 'mdi-account',
            isAdmin: false,
          },
      isMobile: false,
      isToggle: false,
      newPic: null,
      userPic: false,
      newName: null,
      newAgentData: null,
      menuMember: {userid: ''},
      memberData: null,
      statusColor: 'grey',
      messageDialog: false,
      message: '',
      upchat: this.$route.meta.upchat,
      hideAvatar: false,
      isAdmin: window.localStorage.getItem('is_staff'),
      showUpchatDashboard: false,
      hasUpchatLogin: false,
      screen_ratio_class_CIC: "",
      screen_ratio_class: "",
      selectedThread: null,
      threadHistory: [],
      user: JSON.parse(window.localStorage.getItem('user')),
      selectedIcon: require("../assets/images/stroke_selected.png"), // 選中時的圖片
      defaultIcon: require("../assets/images/stroke_non_selected.png"), // 未選中時的圖片
      thread_id: "",
      threadList:[],
      targetThread:[],
      drawer: false,
      hoverIndex: null,
      documentAgentHistory: [],
      selectedAgentIndex: null,
      agenthoverIndex: null,
      showDocumentAgent: false,
      // 客製外觀參數
      new_question_btn: "#14C6DE",
      portal_menubar_background: "#F3F3EE",
      logo_width: 120,
      logo_height: 25.96,
    };
  },
  watch: {
    "member": async function () {
      if (this.member.userid != '') {
        this.menuMember = this.member;
        await this.getUserPhoto();
      }
    },
    "newPic": function () {
      this.menuMember.pic = this.newPic
    },
    "newName": function () {
      this.menuMember.name = this.newName.last_name + ' ' + this.newName.first_name;
    },
    "newAgentData": function () {
      this.menuMember.status = this.newAgentData.status;
    }
  },
  async created() {
    await PreferenceService.enableDocumentAgent().then((response)=>{
      if(response.data){
          this.showDocumentAgent = response.data == 'Y' ? true:false;
      }
    })
    if (window.localStorage.getItem('upchat_login') != null)
      this.hasUpchatLogin = window.localStorage.getItem('upchat_login') === 'true' ? true : false;
    this.menuMember = this.member;
    this.menuMember.email = this.user.email;
    let access_token = window.localStorage.getItem('access_token');
    if (access_token != null) {
      this.getUserDetail();
    }
    window.addEventListener("message", (msg) => {
      this.hide(msg.data);
    }, false);
    window.addEventListener('resize', () => {
      this.return_screen_class();
    })
    await this.getPortalColorSetting();
    this.return_screen_class();
    this.getThreadListData();
    this.getUserDocumentAgentMenuList();
  },

  mounted() {
    passData.$on("menuBarPic", (e) => {
      this.newPic = e
    })
    passData.$on("menuBarName", (e) => {
      this.newName = e
    })
    passData.$on("menuBarAgentData", (e) => {
      this.newAgentData = e;
    })
  },
  methods: {
    async getPortalColorSetting() {
      let color_setting;
      const root = document.documentElement;
      await PreferenceService.getPortalColorSetting().then((response)=>{
        color_setting = response.data;
        if (color_setting) {
          root.style.setProperty('--record_border', color_setting.record_border);
          root.style.setProperty('--toggle_setting', color_setting.toggle_setting);
          root.style.setProperty('--checkbox_setting', color_setting.checkbox_setting);
          root.style.setProperty('--new_question_btn', color_setting.new_question_btn);
          this.new_question_btn = color_setting.new_question_btn;
          root.style.setProperty('--portal_background', color_setting.portal_background);
          root.style.setProperty('--references_border', color_setting.references_border);
          root.style.setProperty('--answer_bottom_border', color_setting.answer_bottom_border);
          root.style.setProperty('--portal_menubar_background', color_setting.portal_menubar_background);
          this.portal_menubar_background = color_setting.portal_menubar_background;
          this.logo_width = color_setting.logo_width;
          this.logo_height = color_setting.logo_height;
        } else {
          root.style.setProperty('--record_border', "#14C6DE");
          root.style.setProperty('--toggle_setting', "#14C6DE");
          root.style.setProperty('--checkbox_setting', "#14C6DE");
          root.style.setProperty('--new_question_btn', "#14C6DE");
          this.new_question_btn = "#14C6DE";
          root.style.setProperty('--portal_background', "#FCFBF7");
          root.style.setProperty('--references_border', "#14C6DE");
          root.style.setProperty('--answer_bottom_border', "#14C6DE");
          root.style.setProperty('--portal_menubar_background', "#F3F3EE");
          this.portal_menubar_background = "#F3F3EE";
          this.logo_width = 120;
          this.logo_height = 25.96;
        }
      })
    },
    return_screen_class() {
      let ratio = window.innerWidth / window.outerWidth;
      if (ratio <= 0.8) {
        this.screen_ratio_class_CIC = "bg-CIC mb-2 v-list-item-small";
        this.screen_ratio_class = "mb-2 v-list-item-small";
      } else {
        this.screen_ratio_class_CIC = "bg-CIC mb-2";
        this.screen_ratio_class = "mb-2";
      }
    },
    remove_upchat_icon() {
      this.upMenuRouters = this.upMenuRouters.filter(el => el.name != "UpChat" && el.name != i18n.t('UPCHAT.CIC'));
    },
    hide(msg) {
      if (msg == 'hide Avatar') {
        this.hideAvatar = true;
      }
    },
    async getThreadListData() {
      await UpGPTPortalDataServices.getThreadList().then((response) => {
        this.ai_bots_list = response.data;
        // 轉換數據格式
        this.threadHistory = this.ai_bots_list.map(el => ({
          id: el.id,
          content: el.title,  // API 返回的 title 作為 content
          thread_url: "/UpGPT_Portal/" + el.id  // 生成對應的 thread_url
        }))
        this.threadList = response.data.map(el => ({
          id: el.id,
          content: el.title,  // API 返回的 title 作為 content
          thread_url: "/UpGPT_Portal/" + el.id,  // 生成對應的 thread_url
          general_instructions: el.general_instructions,
          attach_document: el.attach_document
        }))
        // this.getselectedThread()
      }).catch(response => {
          // Redirect to PermissionError page if error status is 403
          if (response.response.status == 403)
          {
              this.$router.replace('/upgpt/PermissionErrorPortal');
          }
          else if(response.response.status == 404)
          {
              this.$router.replace('/upgpt/PageNotFound');
          }
      });
    },
    async getUserDocumentAgentMenuList(){
      await UpGPTPortalDataServices.getUserDocumentAgentMenuList().then((response) => {
        let data = response.data;
        this.documentAgentHistory = data.map(el => ({
          id: el.id,
          content: el.agent_name,  // API 返回的 title 作為 content
          // thread_url: "/UpGPT_Portal/" + el.id  // 生成對應的 thread_url
        }))
      })
    },
    async getUserDetail() {
      await PersonalSettingService.getCurrentUserDetail()
          .then(response => {
            this.memberData = response.data;
          })
    },
    setLang() {
      let lang = window.localStorage.getItem('language');
      if (lang != 'zh_TW') {
        window.location.reload();
      }
    },
    getUserPhoto() {
      if (this.userPic === false) {
        PersonalSettingService.getCurrentUserDetail()
            .then(response => {
              if (response.data[0].usersetting.photo != null) {
                this.menuMember.pic = response.data[0].usersetting.photo
                const USER = 'user';
                let userJson = window.localStorage.getItem(USER);
                let user = JSON.parse(userJson);
                user.pic = response.data[0].usersetting.photo;
                window.localStorage.setItem(USER, JSON.stringify(user));
                this.userPic = true
              } else {
                this.menuMember.pic = '';
              }
              this.setLang()
            })
      }
    },
    change_main_view(args){
      this.drawer = false;
      if(!this.generating){
        this.selectedThread = null;
        this.$emit("getQuestionDetail", args);
      }
    },
    toLanding() {
      this.change_main_view('insert')
    },
    toDocumentAgentTemplate(){
      this.change_main_view('document_agent_template')
    },
    toUserSetting(){
      this.change_main_view('setting')
    },
    toMyKnowledge(){
      this.change_main_view('knowledges')
    },
    async onlogout() {
      this.messageDialog = true;
      this.message = i18n.t("GENERAL.LOGOUT_MSG");
      this.message = i18n.t("GENERAL.LOGOUT_MSG");
    },
    ...mapActions([
      'logout',
    ]),
    async changeStatus(newStatus) {
      await this.getUserDetail();

      if (this.memberData != null) {
        this.memberData[0].usersetting.status = newStatus;

        PersonalSettingService.updateDetail(this.memberData[0].id, this.memberData[0])
            .then(response => {
              // set menuMember data to new status
              this.menuMember.status = response.data.usersetting.status;

              // set local storage data to new status
              let userJson = window.localStorage.getItem('user');
              let user = JSON.parse(userJson);
              user.status = response.data.usersetting.status;
              window.localStorage.setItem('user', JSON.stringify(user));
            })
            .catch(response => {
              console.log(response);
            })
      }
    },
    async onEmitMessageDialog(val) {
      this.messageDialog = false;
      if (val) {
        if (this.menuMember.is_service_agent) {
          this.memberData[0].usersetting.status = 'OFFLINE';
          this.memberData[0].usersetting.default_value = JSON.parse(window.localStorage.getItem('user')).default_value
          await PersonalSettingService.updateDetail(this.memberData[0].id, this.memberData[0])
        }
        let tenant = window.localStorage.getItem('tenant');

        await this.logout()
            .then(() => {
              let redirectTo = (tenant != null || tenant != '') ? `/login?tenant=${tenant}&upgpt=Y` : '/login?upgpt=Y';
              this.menuMember = {userid: ''};
              this.userPic = false;
              this.$emit('logoutSuccess');
              this.$router.push(redirectTo);
              this.showUpchatDashboard = false;
              this.remove_upchat_icon();
            })
      }
    },
    updateseletedThread(index, item) {
      if(!this.generating){
        this.selectedThread = index;
        this.targetThread = this.threadList.filter(i=> i.id == item.id)
        this.$emit("getQuestionDetail", 'list', this.targetThread);
        this.drawer = false;
      }
    },
    updateDocumentAgent(index, item){
      if(!this.generating){
        this.selectedAgentIndex = index;
        this.$emit("getQuestionDetail", 'document_agent_detail', item);
        this.drawer = false;
      }
    },
    deleteSeletedThread(item){
      this.$emit("deleteThreadAgentItem", item, 'delThread');
      this.drawer = false;
    },
    deleteSelectedUserAgent(item){
      this.$emit("deleteThreadAgentItem", item, 'delUserAgent');
    },
    async set_selected_thread(index){
        this.selectedThread= index;
    },
    async updateCurrentThread(thread_id){
      await this.getThreadListData();
      this.targetThread = this.threadList.filter(i=> i.id == thread_id);
      this.$emit("getQuestionDetail", 'follow_question', this.targetThread);
    }
  },
  computed: {
    ...mapState([
      'isUpsideExtension',
    ]),
    endPointDrawerWidth(){
      const { xs, sm, md, lg, xl } = this.$vuetify.breakpoint
      if (xs) return '70%'
      if (sm) return '70%'
      if (md) return '30%'
      if (lg) return '30%'
      if (xl) return '30%'
      return '30%';
    },
  }
}

</script>
<style lang="scss" scoped>
@import "../style/portal/typography.scss";
:root {
  --record_border: #14C6DE;
  --toggle_setting: #14C6DE;
  --checkbox_setting: #14C6DE;
  --portal_background: #FCFBF7;
  --references_border: #14C6DE;
  --answer_bottom_border: #14C6DE;
  --portal_menubar_background: #F3F3EE;
}
.v-btn__content {
  padding: 0 !important;
}
.custom-list{
  overflow-x: hidden;
}
.custom-list::-webkit-scrollbar {
  width: 6px; /* 調整滾動條寬度 */
}
.custom-list::-webkit-scrollbar-track {
  background:  var(--portal_menubar_background) !important;
}
.custom-list::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3) ;
  border-radius: 10px;
}
.poweredby {
  font-family: 'Segoe UI','SegoeUI','Noto Sans TC', 'Roboto', sans-serif !important;
  font-weight: 400;
  font-size: 10px;
  color: #888888;
  max-width: 120px;
  text-align: right;
  margin-top: -10px;
}
.poweredby-mobile {
  font-family: 'Segoe UI','SegoeUI','Noto Sans TC', 'Roboto', sans-serif !important;
  font-weight: 400;
  font-size: 10px;
  color: #888888;
  max-width: 120px;
  text-align: right;
}
.upside-logo-style {
  margin-left: 60px !important;
}
.selected-thread-border {
 border-left: 2px solid var(--record_border);
 height: 36px;
}
.default-thread-border {
 border-left: 2px solid #CCC ;
 height: 36px;
}
.selected-thread-border-mobile {
 border-left: 1px solid var(--record_border);
 height: 36px;
}
.default-thread-border-mobile {
 border-left: 1px solid #CCC ;
 height: 36px;
}
.cross-box {
  max-height: 16px;
  max-width: 16px;
  min-width: 16px;
  min-height: 16px;
  background-color: var(--new_question_btn);
  clip-path: polygon(
    0% 45%,
    45% 45%,
    45% 0%, 55% 0%,
    55% 45%,
    100% 45%, 100% 55%,
    55% 55%,
    55% 100%, 45% 100%,
    45% 55%,
    0% 55%
  );
  margin-right: 4px;
}
#menu-bar-portal {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  min-height:0;
  width: 240px; //sidebar 寬度
  z-index: 10;
  flex-direction: column;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;  //禁止壓縮
}
.history-list-wrapper {
  max-height: 180px;  //5行高度
  overflow-y: auto;
}
.history-list-wrapper-expanded {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.agent-section {
  min-height: 0;
}
.agent-list-wrapper {
  overflow-y: auto;
}
.custom-scroll-area {
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(153, 153, 153, 0.3);
    border-radius: 10px;
  }
}
.add_thread_lists {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.add_thread .h4-en {
  font-size: 16px;
  white-space: nowrap;
}
.mobile-drawer-with-footer-space {
  padding-bottom: 60px;
}
</style>